var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14h3.912c1.933 0 3.5-1.567 3.5-3.5S8.979 7 10.912 7H18M0 14h3.912c1.933 0 3.5 1.567 3.5 3.5s1.567 3.5 3.5 3.5H18M14 21h3.912c1.933 0 3.5 1.567 3.5 3.5s1.567 3.5 3.5 3.5H32M14 7h3.912c1.933 0 3.5-1.567 3.5-3.5s1.567-3.5 3.5-3.5H32",
    transform: "translate(8 10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7h3.912c1.933 0 3.5 1.567 3.5 3.5s1.567 3.5 3.5 3.5H32M15 7L32 7M14 21L32 21",
    transform: "translate(8 10)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.1c19ada243be40a640cbce520d88d34e.svg";
export { ForwardRef as ReactComponent };